<template>
  <div class="box">
    <el-row>
      <h3>网络探测</h3>
      <event-list @clickRow="clickRow" />
    </el-row>
    <el-row v-if="currentRow">
      <!-- <h3>探测明细</h3>
      <event-detail :rowId="currentRow.guid" /> -->

      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <h3 class="collapse-title">探测明细</h3>
          </template>
          <event-detail :rowId="currentRow.guid" />
        </el-collapse-item>
      </el-collapse>
    </el-row>

    <div v-show="showTop" class="el-backtop" style="right: 0px; bottom: 150px;" @click="goTop">
      <i class="el-icon-caret-top"></i>
    </div>
  </div>
</template>
<script>
  import EventList from './EventList'
  import EventDetail from './EventDetail'
  export default {
    name: 'probing',
    components: {
      EventList,
      EventDetail
    },
    data: vm => ({
      currentRow: null,
      showTop: false,
      activeNames: ['1']
    }),
    mounted() {
      window.addEventListener('mousewheel', this.debounce(this.handleScroll,300), true)
      ||
      window.addEventListener("DOMMouseScroll",this.debounce(this.handleScroll,300),false)
    },
    methods: {
      // 点击某一行的探测事件，显示探测明细
      clickRow(row) {
        this.currentRow = null
        setTimeout(() => {
          this.currentRow = row
        }, 10)
      },
      goTop() {
        window.scrollTo(0, 0)
        this.showTop = false
      },
      debounce(func, wait) {
        let timeout;
        return function() {
          let context = this;
          let args = arguments;
          if (timeout) clearTimeout(timeout);
          timeout = setTimeout(() => {
            func.apply(context, args)
          }, wait);
        }
      },
      //判断滚动方向
      handleScroll(e) {
        if(window.scrollY > 20){
          this.showTop = true
        }else{
          this.showTop = false
        }
      },
    },
  }
</script>
<style scoped>
.collapse-title {
  flex: 1 1 auto;
  order: 1;
}
</style>
